import * as AbstractImage from "abstract-image";

export const seriesColors = {
  // REDS
  Red1: { a: 255, r: 200, g: 30, b: 45 },
  Red2: { a: 255, r: 255, g: 60, b: 60 },
  Red3: { a: 255, r: 180, g: 70, b: 90 },
  Red4: { a: 255, r: 140, g: 40, b: 60 },

  // YELLOWS
  Yellow1: { a: 255, r: 255, g: 200, b: 0 },
  Yellow2: { a: 255, r: 240, g: 170, b: 20 },
  Yellow3: { a: 255, r: 200, g: 150, b: 0 },
  Yellow4: { a: 255, r: 160, g: 120, b: 20 },

  // GREENS
  Green1: { a: 255, r: 30, g: 180, b: 50 },
  Green2: { a: 255, r: 90, g: 220, b: 90 },
  Green3: { a: 255, r: 60, g: 160, b: 80 },
  Green4: { a: 255, r: 30, g: 110, b: 50 },

  // BLUES
  Blue1: { a: 255, r: 50, g: 100, b: 255 },
  Blue2: { a: 255, r: 100, g: 150, b: 255 },
  Blue3: { a: 255, r: 80, g: 120, b: 200 },
  Blue4: { a: 255, r: 30, g: 70, b: 160 },

  // ORANGES
  Orange1: { a: 255, r: 255, g: 120, b: 0 },
  Orange2: { a: 255, r: 240, g: 100, b: 20 },
  Orange3: { a: 255, r: 220, g: 90, b: 30 },
  Orange4: { a: 255, r: 180, g: 70, b: 20 },

  // PURPLES
  Purple1: { a: 255, r: 180, g: 100, b: 255 },
  Purple2: { a: 255, r: 150, g: 80, b: 220 },
  Purple3: { a: 255, r: 120, g: 70, b: 190 },
  Purple4: { a: 255, r: 100, g: 50, b: 160 },

  // PINKS
  Pink1: { a: 255, r: 255, g: 100, b: 180 },
  Pink2: { a: 255, r: 240, g: 80, b: 150 },
  Pink3: { a: 255, r: 220, g: 70, b: 130 },
  Pink4: { a: 255, r: 180, g: 50, b: 100 },

  // BROWNS
  Brown1: { a: 255, r: 160, g: 82, b: 45 },
  Brown2: { a: 255, r: 140, g: 70, b: 35 },
  Brown3: { a: 255, r: 120, g: 60, b: 30 },
  Brown4: { a: 255, r: 100, g: 50, b: 25 },

  // GRAYS
  Gray1: { a: 255, r: 220, g: 220, b: 220 },
  Gray2: { a: 255, r: 160, g: 160, b: 160 },
  Gray3: { a: 255, r: 100, g: 100, b: 100 },
  Gray4: { a: 255, r: 60, g: 60, b: 60 },

  // CYANS
  Cyan1: { a: 255, r: 0, g: 200, b: 200 },
  Cyan2: { a: 255, r: 40, g: 180, b: 200 },
  Cyan3: { a: 255, r: 30, g: 160, b: 180 },
  Cyan4: { a: 255, r: 20, g: 130, b: 160 },

  // TEALS
  Teal1: { a: 255, r: 0, g: 160, b: 160 },
  Teal2: { a: 255, r: 0, g: 130, b: 130 },
  Teal3: { a: 255, r: 30, g: 110, b: 110 },
  Teal4: { a: 255, r: 20, g: 90, b: 90 },

  // EXTRAS
  Black: { a: 255, r: 0, g: 0, b: 0 }
};
export const backgroundColor = AbstractImage.white;
export const tempLines = AbstractImage.gray;
export const energyLines = AbstractImage.gray;
export const binTimeLines = AbstractImage.gray;
export const chartBounds = AbstractImage.black;
export const energyCurve = AbstractImage.red;
export const binTimeCurve = AbstractImage.blue;
